module.exports = __webpack_public_path__ + "img/featureR.127542bb.png";